import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  DwConfigService, DwConfigServiceToken, DwTermsOfServiceAcceptedResult
} from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';

/** Prevents CAP's layout from opening its own terms modal. */
@Injectable()
export class AviatorTermsOfServiceManagerService {
  termsOfServiceAccepted = false;
  checkingTermsOfService = false;
  private readonly securityApi: string;

  constructor(private http: HttpClient, @Inject(DwConfigServiceToken) config: DwConfigService) {
    this.securityApi = `${config.coreConfig.apiRoot}/security`;
  }

  setupTermsOfServiceEvents(): void { }

  handleTermsOfService(): Observable<any> {
    return of(null);
  }

  acceptTermsOfService(): Observable<DwTermsOfServiceAcceptedResult> {
    return this.http.post<DwTermsOfServiceAcceptedResult>(`${this.securityApi}/terms/accept`, {});
  }
}
